<template>
	<div class="application-page jobs">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation page="jobs"/>
				</b-col>
				<b-col md="6">
					<h1>{{ title }}</h1>
					<template v-if="job">
						<div class="job-listing">
							<div class="job-listing--items">
								<div class="job-listing--item">
									<DisplayNew
										:job="job"
										teaser
									/>
								</div>
							</div>
						</div>
						<Listing
							class="mt-4"
							:job="job"
							:filter-values="filterValues"
							:only-favorites="onlyFavorites"
							@loaded="listingLoaded"
						/>
					</template>
				</b-col>
				<!--<b-col v-if="hasItemsWithoutFilter && !onlyFavorites" md="3">
					<div class="sidebar-jon">
						<div class="sidebar-job--avatar">
							<div>Such doch noch genauer, ich helfe dir gerne dabei:</div>
							<div>
								<img src="/img/jon.svg" alt="Jon" />
								<div class="arrow-down"></div>
							</div>
						</div>
						<FilterValues
							:filter-values="filterValues"
							@resetFilterValues="resetFilterValues"
							@removeFilterValue="removeFilterValue"
						/>
						<div class="sidebar-jon--button-container">
							<Button
								text="Filter öffnen"
								icon="search"
								@click="openFuzzyMatrix"
							/>
						</div>
					</div>
				</b-col>-->
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Navigation from "@/vue/application/profile/Navigation";
import FuzzyMatrix from "@/vue/application/job/fuzzy-matrix/Container";
import Listing from "@/vue/application/job/listing/Container";
import _ from "lodash";
import DisplayNew from "@/vue/application/job/DisplayNew";
import GetList from "@/api/application/job/GetList";
import Button from "@/vue/common/Button";
import {mapActions} from "vuex";
import FilterValues from "@/vue/application/job/fuzzy-matrix/FilterValues";
import {getQueryParams} from "@/helper/Url";

export default {

	components: {
		FilterValues,
		Button,
		DisplayNew,
		Navigation,
		FuzzyMatrix,
		Listing,
	},

	props: {
		jobId: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
	},

	mounted ()
	{
		this.loadJob();
	},

	data ()
	{
		const queryParams = getQueryParams();

		return {
			loadingJob: true,
			job: undefined,
			filterValues: [],
			matrix: undefined,
			hasItemsWithoutFilter: undefined,
			onlyFavorites: queryParams.onlyFavorites === '1',
		};
	},

	methods: {
		...mapActions('job/fuzzyMatrix', {
			showFuzzyMatrix: 'show'
		}),
		listingLoaded ({ totalCount })
		{
			if (this.hasItemsWithoutFilter === undefined)
			{
				this.hasItemsWithoutFilter = totalCount > 0;
			}
		},
		resetFilterValues ()
		{
			this.filterValues = [];
		},
		removeFilterValue (value)
		{
			this.filterValues = _.filter(this.filterValues, innerValue => innerValue.id !== value.id);
		},
		openFuzzyMatrix ()
		{
			this.showFuzzyMatrix({
				job: this.job,
				filterValues: this.filterValues,
				onFilter: ({ filterValues }) =>
				{
					this.filterValues = filterValues;
				},
			});
		},
		async loadJob ()
		{
			this.loadingJob = true;

			try
			{
				const response = await new GetList()
					.setJob(this.jobId)
					.call();

				this.job = _.first(response.data);
			}
			catch (e)
			{

			}

			this.loadingJob = false;
		},
	}
}
</script>
